import React, { useState, useEffect, useRef } from 'react';
import './DynaInput.scss';
import './DynaSelectBox.scss';

const DynaSelectBox = ({ options, label, className, hasFilter, style, onChange, value, activeFocus, hasAllOption, onOpen }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const selectRef = useRef(null);

  const svgArrow = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#B9B9B9"
      d="M6.433 8.95c0-.159.059-.317.184-.442a.629.629 0 01.883 0l2.5 2.5 2.5-2.5a.629.629 0 01.883 0 .629.629 0 010 .883l-2.941 2.942a.629.629 0 01-.884 0L6.617 9.391a.618.618 0 01-.184-.441z"
    ></path>
  </svg>

  const toggleDropdown = (event) => {
    event.stopPropagation();
    if (!isOpen) {
      onOpen?.(); // برای فراخوانی یک تابع هنگام باز شدن
    }
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (value) {
      const selected = options.find((option) => value === option.value);
      if (selected) {
        setSelectedOption(selected.label);
        onChange(selected);
      } else {
        setSelectedOption("");
        onChange({ value: "", label: "" });
      }
    } else {
      setSelectedOption("");
    }
  }, [value]);

  const handleOptionClick = (option) => {
    if (option.value === "") {
      onChange({ value: "", label: "همه" });
    } else {
      setSelectedOption(option.label);
      onChange(option);
    }
    setIsOpen(false);
  };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    setIsOpen(true);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      const optionsLength = filteredOptions.length;
      let newIndex = highlightedIndex;

      if (event.key === 'ArrowDown') {
        newIndex = (newIndex + 1) % optionsLength;
      } else if (event.key === 'ArrowUp') {
        newIndex = (newIndex - 1 + optionsLength) % optionsLength;
      }

      setHighlightedIndex(newIndex);
    } else if (event.key === 'Enter' && highlightedIndex !== -1) {
      handleOptionClick(filteredOptions[highlightedIndex]);
    }
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
    option.value.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (selectRef.current && highlightedIndex !== -1) {
      const listItems = selectRef.current.querySelectorAll('li');
      if (listItems.length > 0) {
        listItems[highlightedIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  }, [highlightedIndex]);

  const handleClickOutside = (event) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(event.target) &&
      event.target !== selectRef.current.previousElementSibling
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const inputKeyDown = (event) => {
    if (event.key === 'Tab') {
      setIsOpen(false)
    }
  }

  const focusHandler = () => {
    if (activeFocus) {
      setIsOpen(true)
    }
  }

  try {
    return (
      <div className={`main-dyna-input dyna-select ${className !== undefined ? className : ""}`}
        onKeyDown={handleKeyDown} onFocus={focusHandler} tabIndex={0} style={style ? style : {}}>
        <label>{label}</label>
        <div className="selected-option" onClick={(e) => toggleDropdown(e)}>
          {selectedOption || 'انتخاب کنید ...'}
        </div>
        {isOpen && (
          <div className="dropdown" ref={selectRef}>

            {hasFilter &&
              <input
                type="text"
                placeholder="جستجو ..."
                value={searchTerm}
                onKeyDown={inputKeyDown}
                onChange={handleInputChange} />
            }

            <ul className="options">
              {hasAllOption && (
                <li
                  key="all"
                  onClick={() => handleOptionClick({ value: "", label: "همه" })}
                  className={highlightedIndex === -1 ? 'highlighted' : ''}
                >همه</li>
              )}
              {filteredOptions.map((option, index) => (
                <li
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={highlightedIndex === index ? 'highlighted' : ''}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={"svg-icon-side"}
          style={{ cursor: 'pointer' }}
          onClick={(e) => toggleDropdown(e)}>
          {svgArrow}
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(DynaSelectBox);